import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TextField from 'components/TextField';
import LegacyEditor from 'components/LegacyEditor';
import WhatToSeeSelect from 'components/WhatToSeeSelect';
import CategoriesSelect from 'components/CategoriesSelect';
import LabelsSelect from 'components/LabelsSelect';

import { PackageEditMainPresentation_data$key } from '__generated__/PackageEditMainPresentation_data.graphql';

type Props = {
  data: PackageEditMainPresentation_data$key;
};

const PackageEditMainPresentation: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment PackageEditMainPresentation_data on Query {
        ...CategoriesSelect_data
        ...LabelsSelect_data
        ...WhatToSeeSelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="presentation" title="Pristatymas">
      <Stack spacing={4}>
        <CategoriesSelect name="categories" label="Kategorijos" data={data} />
        <LabelsSelect name="labels" label="Etiketės" data={data} />
        <TextField fullWidth name="subtitle" label="Paantraštė" />

        <TextField
          fullWidth
          name="descriptionTitle"
          label="Aprašymo antraštė"
        />

        <LegacyEditor name="descriptionText" label="Aprašymas" />
        <TextField fullWidth name="notesTitle" label="Pastabų antraštė" />
        <LegacyEditor name="notesText" label="Pastabos" />
        <TextField fullWidth name="organiser" label="Organizatorius" />

        <WhatToSeeSelect
          name="whatToSee"
          label="Ką veikti straipsnis"
          data={data}
        />
      </Stack>
    </Section>
  );
};

export default PackageEditMainPresentation;
